var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v(_vm._s(_vm.terminal))]),_c('br'),_c('pre',[_vm._v(_vm._s(_vm.score))])])}
var staticRenderFns = []

export { render, staticRenderFns }